import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { BookingPill } from "PFApp/components/pills/booking_pill";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import useBookingCategories from "PFCore/hooks/use_booking_categories";

import css from "./booking_category_information.module.scss";

export const BookingCategoryInformation = () => {
  const activity = useCurrentActivity();
  const { getBookingCategory } = useBookingCategories();

  if (!activity.booking_category_id) {
    return null;
  }

  const category = getBookingCategory(activity.booking_category_id);

  return (
    <Inline alignItems="center" justifyContent="space-between" gap="spacingMd">
      <Typography variant="labelRegular">{category?.display_as}</Typography>
      <BookingPill className={css.pill} category={category} iconSize="xxs" center />
    </Inline>
  );
};
